import { ThemeSwitchContext } from "../providers/ThemeProvider";
import { useContext } from "react";

export default function useThemeSwitch() {
  return useContext(ThemeSwitchContext);
}
